import { ChartSkeleton } from '@/components';
import { CurrencyValue, BarChart } from '@blockanalitica/ui';
import { useMemo } from 'react';
import { useTheme } from 'styled-components';
import { SimpleChartData } from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';

export interface DepositsData {
  name: string;
  deposit: string;
}

export default function SurplusDepositsChart({
  data
}: {
  data: DepositsData[];
}) {
  const theme = useTheme();
  const datasets = useMemo(() => {
    return [
      {
        xField: 'name',
        yField: 'deposit',
        label: 'Ilks',
        backgroundColor: theme.colors.chartLine
      }
    ];
  }, [theme]);

  const xScaleValueFormatter = useMemo(() => {
    return (value) => {
      return data[value]?.name;
    };
  }, [data]);

  const subValueFormatter = useMemo(() => {
    return function subValueFormatter(value: string) {
      return <>{value}</>;
    };
  }, []);

  const valueFormatter = useMemo(() => {
    return function valueFormatter(value: string) {
      return (
        <CurrencyValue
          value={value}
          options={{
            currency: 'DAI'
          }}
        />
      );
    };
  }, []);

  const config = useMemo(() => {
    return {
      options: {
        scales: {
          x: {
            type: 'category' as const
          }
        }
      }
    };
  }, []);

  if (data) {
    return (
      <BarChart
        data={data as unknown as SimpleChartData[]}
        datasets={datasets}
        config={config}
        defaultDataIndex={0}
        xScaleValueFormatter={xScaleValueFormatter}
        subValueFormatter={subValueFormatter}
        valueFormatter={valueFormatter}
      />
    );
  }
  return <ChartSkeleton />;
}
